import { callFunction } from '@utils/cloudbase';
import { message } from 'antd';

// 通用响应处理
const handleResponse = (result) => {
  if (!result) {
    throw new Error('服务器响应为空');
  }

  if (result.code === 0) {
    return result.data;
  }
  
  throw new Error(result.message || '操作失败');
};

// 业务API函数
export const getBusinessCards = async ({ page = 1, pageSize = 10, name = '', phone = '' } = {}) => {
  try {
    const result = await callFunction('businessCard', {
      action: 'list',
      page,
      pageSize,
      name,
      phone
    });
    return handleResponse(result);
  } catch (error) {
    message.error(error.message || '获取名片列表失败');
    throw error;
  }
};

export const getBusinessCard = async (id) => {
  try {
    const result = await callFunction('businessCard', {
      action: 'get',
      id
    });
    return handleResponse(result);
  } catch (error) {
    message.error(error.message || '获取名片详情失败');
    throw error;
  }
};

export const createBusinessCard = async (data) => {
  try {
    console.log('Creating business card with data:', data); // 添加日志
    
    const result = await callFunction('businessCard', {
      action: 'create',
      ...data
    });
    
    console.log('Create business card response:', result); // 添加日志
    return handleResponse(result);
  } catch (error) {
    console.error('Create business card error:', error); // 添加错误日志
    message.error(error.message || '创建名片失败');
    throw error;
  }
};

export const updateBusinessCard = async (id, data) => {
  try {
    const result = await callFunction('businessCard', {
      action: 'update',
      id,
      ...data
    });
    return handleResponse(result);
  } catch (error) {
    message.error(error.message || '更新名片失败');
    throw error;
  }
};

export const deleteBusinessCard = async (id) => {
  try {
    const result = await callFunction('businessCard', {
      action: 'delete',
      id
    });
    return handleResponse(result);
  } catch (error) {
    message.error(error.message || '删除名片失败');
    throw error;
  }
};